import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Url } from "./Url";
import ContextStates from "../context/ContextStates";
import FViewDataCliente from "./admin/fViewDataCliente";
import FEditCliente from "./admin/fEditCliente";
import { Link } from "react-router-dom"
import { motion } from 'framer-motion';
import { areaAnimateLR } from './Animations';


const AdminCustomer = () => {
    //const [] = useState(false)
    const { cliente, setClienteSelected, editCliente, setEditCliente } = useContext(ContextStates);

    useEffect(() => {
        //console.log("si viene por aqui")
        setClienteSelected(cliente)
    }, [cliente])
    /*useEffect(() => {
        const checkPedidos = async() => {
            const formData=new FormData()
            formData.append('search',textSearch);
            try{
                const results = await axios({
                    url: Url+'api/searchList.php',
                    method: 'POST',
                    data: formData,
                })
                console.log(results)
                setResultado(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        checkPedidos()
    },[textSearch])*/

    return (
        <div className="w-10/12 mx-auto mb-20">
            <h1 className="text-center text-gray-600 text-2xl">Mis datos </h1>
            <div className="w-full">
                {!editCliente ? (
                    <div className="w-full">
                        <FViewDataCliente />
                        <button
                            type="button"
                            className="w-1/4 sm:w-1/6 shadow-md p-3 bg-orange-600 text-gray-100 hover:bg-orange-400 transition-all uppercase font-bold rounded-lg"
                            onClick={() => setEditCliente(true)}
                        >Editar Datos</button>
                    </div>
                ) : (
                    <div className="w-full">
                        <FEditCliente />
                        
                    </div>
                )}
            </div>
        </div>
    )
}

export default AdminCustomer